import React, { createContext, useReducer } from 'react';
import Reducer from './reducer';

const initialState = {};

const MyAccountStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <MyAccountContext.Provider value={[state, dispatch]}>{children}</MyAccountContext.Provider>
  );
};

export const MyAccountContext = createContext(initialState);
export const MyAccountInitialState = initialState;
export default MyAccountStoreProvider;
